import React, { Fragment, useState } from "react";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment'


function MUIDatePicker(props) {
  const [selectedDate, handleDateChange] = useState(null);
  const { label } = props

  return (
    <Fragment>
      <MuiPickersUtilsProvider utils={ MomentUtils }>
        
          <KeyboardDatePicker
            label={label}
            clearable
            value={selectedDate}
            onChange={date => handleDateChange(date)}
            format="DD/MM/YYYY"
            className="date-picker"
          />
          
      </MuiPickersUtilsProvider>
    </Fragment>
    
  );
}

export default MUIDatePicker;


// WEBPACK FOOTER //
// ./src/components/MUIDatePicker/index.js